export default __webpack_public_path__ + "static/media/shopee-pay.ae08bd40.svg";